module.exports = __webpack_public_path__ + "8e27cb55ca3baa4a7a72e3bd94b763b6.pdf";